

import CourseAttendance from './screens/CourseAttendance'; 
import CourseHome from './screens/CourseHome'; 
import CourseCalif from './screens/CourseCalif';

const routes = [
  

    {
      path: "/course/:id/attendance",
      name: "Asistencias",
      icon: "nc-icon nc-circle-10",
      exact: true,
      component: CourseAttendance,
      layout: "/admin",
      roleID: ['COURSE_PAGE','TEACHER','TUTOR'] 
    },
    {
      path: "/course/:id/calif",
      name: "Panel de control",
      icon: "nc-icon nc-circle-10",
      exact: true,
      component: CourseCalif,
      layout: "/admin",
      roleID: ['COURSE_PAGE','TEACHER','TUTOR'] 
    },
    {
      path: "/course/:id", 
      name: "Panel de control",
      icon: "nc-icon nc-circle-10",
      exact: true,
      component: CourseHome,
      layout: "/admin",
      roleID: ['COURSE_PAGE','TEACHER','TUTOR'] 
    },
    
  ];
  
  export default routes;